import { ProductBlockItem } from "../../../../models/domains/pbm/Benefit/product-block-item";
import { ProductConfiguration } from "./../../../../models/domains/pbm/Benefit/product-configuration";
import { Injectable } from "@angular/core";
import { AbstractParser } from "../../parser";
import { ProductType } from "src/app/ui/models/domains/pbm/Benefit/product-type";
import { ProductSubtype } from "src/app/ui/models/domains/pbm/Benefit/product-subtype";
import { ProductConfigurationCluster } from "src/app/ui/models/domains/pbm/Benefit/product-configuration-cluster";
import { ProductClusterExceptInfo } from "src/app/ui/models/domains/pbm/Benefit/product-cluster-except-info";
import { IBlockItem } from "src/app/ui/models/domains/pbm/Benefit/iblock-list-item";
import { TherapeuticClassBlockItem } from "src/app/ui/models/domains/pbm/Benefit/therapeutic-class-block-item";
import { BlockItemType } from "src/app/ui/models/domains/pbm/Benefit/block-item-type";
import { ProductClusterManagement } from "src/app/ui/models/domains/pbm/Benefit/product-cluster-management";
import { ClusterType } from "src/app/ui/models/domains/pbm/Benefit/product-clustertype";

@Injectable()
export class ProductConfigurationParser extends AbstractParser<ProductConfigurationCluster> {
  parse(payload: any): ProductConfigurationCluster {
    const productConfigurationCluster = new ProductConfigurationCluster();
    productConfigurationCluster.setKey(payload.Key);
    productConfigurationCluster.setCompanyFiscalNumber(payload.CompanyFiscalNumber);
    productConfigurationCluster.setProductConfiguration(this.addProductConfiguration(payload.ProductConfiguration));
    productConfigurationCluster.setProductClusterExceptInfo(this.addProductClusterExceptInfo(payload.ProductClusterExceptInfo));
    productConfigurationCluster.setProductMaxCount(payload.ProductMaxCount);
    productConfigurationCluster.setProductFrequency(payload.ProductFrequency);
    productConfigurationCluster.setProductRepeatPurchase(payload.ProductRepeatPurchase);
    productConfigurationCluster.setBlockListConfiguration(this.parseBlockListConfiguration(payload.BlockListConfiguration));
    productConfigurationCluster.setClustersForManagement(this.parseClusterConfiguration(payload.ProductClusterManagement));
    return productConfigurationCluster;
  }

  private parseClusterConfiguration(data: any): Array<ProductClusterManagement> {
    if (data && data.ClustersForManagement) {
      let config = data.ClustersForManagement || [];
      return config.map((x) => {
        const _c = new ProductClusterManagement();
        let clusterType = new ClusterType();
        clusterType.Key = x.ClusterId;
        _c.setClusterType(clusterType);
        _c.setPurchase(x.PurchaseEnabled);
        _c.setSubsidy(x.Subsidy, x.SubsidyEnabled);
        _c.setDiscount(x.DiscountPercentValue, x.DiscountEnabled);
        _c.setFormPayment(x.FormPayment);
        return _c;
      });
    }

    return new Array<ProductClusterManagement>();
  }

  private addProductConfiguration(payloadProductConfiguration: any): Array<ProductConfiguration> {
    const productConfigurationList: Array<ProductConfiguration> = payloadProductConfiguration.map((configuration) => {
      const productConfiguration = new ProductConfiguration();
      productConfiguration.setProductType(this.addProductType(configuration.ProductTypeKey));
      productConfiguration.setProductSubType(this.addProductSubType(configuration.ProductSubTypeKey));
      productConfiguration.setPurchaseEnabled(configuration.PurchaseEnabled);
      productConfiguration.setSubsidyEnabled(configuration.SubsidyEnabled);
      productConfiguration.setSubsidy(configuration.Subsidy);
      productConfiguration.setDiscountEnabled(configuration.DiscountEnabled);
      productConfiguration.setDiscountPercentValue(configuration.DiscountPercentValue);
      productConfiguration.setFormPayment(configuration.FormPayment);
      return productConfiguration;
    });
    return productConfigurationList;
  }

  private addProductType(key: string): ProductType {
    const productType = new ProductType();
    productType.setKey(key);
    productType.setValue("");
    return productType;
  }

  private addProductSubType(key: string): ProductSubtype {
    const productSubType = new ProductSubtype();
    productSubType.setKey(key);
    productSubType.setValue("");
    return productSubType;
  }

  private addProductClusterExceptInfo(payload: any): ProductClusterExceptInfo {
    const productClusterExceptInfo = new ProductClusterExceptInfo();
    productClusterExceptInfo.setAllowedPurchase(payload.AllowedPurchase);
    productClusterExceptInfo.setAllowedCheckoutOnline(payload.AllowedCheckoutOnline);
    productClusterExceptInfo.setAllowedFullEmploymentPayroll(payload.AllowedFullEmploymentPayroll);
    return productClusterExceptInfo;
  }

  private parseBlockListConfiguration(payload: any): IBlockItem[] {
    const blockListConfiguration: IBlockItem[] = payload.BlockListItems.map((item) => {
      if (item.BlockListItemType === BlockItemType.Product) {
        const product = new ProductBlockItem();
        product.setProductName(item.ProductName);
        product.setEan(item.Ean);
        product.setProductKey(item.ProductKey);
        return product;
      } else if (item.BlockListItemType === BlockItemType.TherapeuticClass) {
        const therapeuticClass = new TherapeuticClassBlockItem();
        therapeuticClass.setDisplayValue(item.TherapeuticClass);
        therapeuticClass.setCode(item.TherapeuticClassCode);
        therapeuticClass.setDescription(item.TherapeuticClass);
        therapeuticClass.setTherapeuticClassKey(item.TherapeuticClassKey);
        return therapeuticClass;
      }
    });

    return blockListConfiguration;
  }
}
